// Moved from src/features/proposalFeature/slice.js - path only, no behavior
// change. `name: "proposalFeature"` and the store key in store.js are both
// kept as-is so redux-persist and every existing dispatch path (including
// LaunchFlow's setCompanyProposals) keep working unchanged.
import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

const initialState = {
  proposals: [],
  companyProposals: [],
  selectedProposalFilters: {
    sort: "-createdAt",
  },
};

const proposalFeatureSlice = createSlice({
  name: "proposalFeature",
  initialState,
  reducers: {
    setProposals: (state, action) => {
      state.proposals = action.payload;
    },
    setCompanyProposals: (state, action) => {
      state.companyProposals = action.payload;
    },
    updateProposalFilters: (state, action) => {
      state.selectedProposalFilters = action.payload;
    },
    resetProposalFilters: (state) => {
      state.selectedProposalFilters = {
        sort: "-createdAt",
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      if (action.payload && action.payload.proposalFeature) {
        const persistedData = action.payload.proposalFeature;
        const persistedFilters = persistedData.selectedProposalFilters;

        return {
          ...state,
          ...persistedData,
          // ADR-F005: never null; always have sort
          selectedProposalFilters: {
            ...(persistedFilters && typeof persistedFilters === "object"
              ? persistedFilters
              : {}),
            sort: persistedFilters?.sort || "-createdAt",
          },
        };
      }
      return state;
    });
  },
});

export const {
  setProposals,
  setCompanyProposals,
  updateProposalFilters,
  resetProposalFilters,
} = proposalFeatureSlice.actions;

export default proposalFeatureSlice.reducer;
